<nav class="navbar app-footer" [ngClass]="{'ais-blue': !red, 'ais-red': red}">
  Akademický informačný systém AiS2 © UPJŠ Košice
</nav>
